var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'Vacancy', params: { alias: _vm.page.alias }}}},[_c('figure',{style:(_vm.background)},[_c('figcaption',[_c('span',{staticClass:"headings"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }